import React, { createContext, useContext, useState, useEffect, useMemo } from "react";
import { getBaseApiUrl } from "../Assets/enviorement";

const BaseUrlContext = createContext();

export const BaseUrlProvider = ({ children }) => {
  const [baseUrl, setBaseUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBaseUrl = async () => {
      try {
        const url = await getBaseApiUrl();
        setBaseUrl(url);
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Failed to load base URL:', error);
        }
        setBaseUrl(null);
      } finally {
        setLoading(false);
      }
    };

    loadBaseUrl();
  }, []);

  const value = useMemo(() => ({ baseUrl, loading }), [baseUrl, loading]);

  return (
    <BaseUrlContext.Provider value={value}>
      {children}
    </BaseUrlContext.Provider>
  );
};

// Hook to use the context
export const useBaseUrl = () => {
  const context = useContext(BaseUrlContext);
  if (context === undefined) {
    throw new Error('useBaseUrl must be used within a BaseUrlProvider');
  }
  return context;
};
